export default class Property {
    constructor(public key: string, public value: string) {
    }
}
